import { Injectable } from '@angular/core';
import { isArray } from '@core/helpers';

import { IAsyncTaskReport, ITask } from './async-task-constants';
import { ApiProvitoolService } from '@core/apis/api-provitool.service';

@Injectable({
  providedIn: 'root'
})
export class SubnetLanImportReport implements IAsyncTaskReport {

  constructor(private readonly apiProvitool: ApiProvitoolService) {
  }

  public generate(task: ITask): string {
    const detail = task.detail;

    if (task.status === 'success') {
      let htmlDetail = `<div>Import des subnets LAN réussi.<br></div>`;
      htmlDetail += this.formatSubnetLanImportSuccess(detail);
      return htmlDetail;

    } else {
      let htmlDetail = `<div>Échec de l'import des subnets LAN.<br></div>`;
      htmlDetail += this.formatSubnetLanImportError(detail);
      return htmlDetail;
    }
  }

  private formatSubnetLanImportSuccess(detail): string {
    if (!detail || !isArray(detail)) {
      return '';
    }
    let successString = '<ul>';
    detail.forEach(success => {
      successString += `
        <br><br>
        <a href="${this.apiProvitool.attachments.downloadUrl(success.attachment_id)}" class="btn btn-default" target="_blank">
          <i class="far fa-file-excel" aria-hidden="true"></i>
          Télécharger le rapport
        </a>
      `;
    });
    successString += '</ul>';
    return successString;
  }

    private formatSubnetLanImportError(detail): string {
    if (!detail) {
      return '<ul><li>Erreur non reconnue.</li></ul>';
    }
    let errors = []
    if (isArray(detail)) {
      errors = detail;
    } else if (typeof detail.error === 'string') {
      try {
        const json = JSON.parse(detail.error.replace(/'/g, '"'));
        errors = Object.keys(json).map((key: string) => ({ error_type: key, error_detail: json[key] }));
      } catch (e) {
        errors = [{
          error_type: detail.error_type || 'UNKNOWN_ERROR',
          error_detail: detail.error
        }];
      }
    } else {
      return '<ul><li>Erreur non reconnue.</li></ul>';
    }
    let errorString = '<ul>';
    errors.forEach(error => {
      errorString += '<li>';
      switch (error.error_type) {
         case 'INVALID_DATA':
          errorString = `Les données du fichier sont invalides. Veuillez télécharger le rapport et corriger le fichier.<br>`;
          break;
        case 'DATA_ALREADY_EXIST':
          errorString = `Les données du fichier sont déjà existantes. Aucun nouveau subnet n'a été créé.<br>`;
          break;
        case 'INVALID_FILE_STRUCTURE':
          errorString = `La structure du fichier est invalide. Veuillez télécharger le rapport et corriger le fichier.<br>`;
          break;
        default:
          errorString = `Une erreur est survenue lors de l'import des objets. Veuillez essayer à nouveau.<br>`;
          break;
      }
      if(error.attachment_id) {
        errorString += `
          <br><br>
          <a href="${this.apiProvitool.attachments.downloadUrl(error.attachment_id)}" class="btn btn-default" target="_blank">
            <i class="far fa-file-excel" aria-hidden="true"></i>
            Télécharger le rapport
          </a>
        `;
      }
      errorString += '</li>';
    });
    errorString += '</ul>';

    return errorString;
  }
}
